/**
 * Analytics configuration
 */

export interface AnalyticsConfig {
  /** Google Analytics 4 Measurement ID */
  ga4MeasurementId: string;
  /** Enable/disable analytics in development environment */
  enableInDevelopment: boolean;
}

export const analyticsConfig: AnalyticsConfig = {
  // Your actual GA4 measurement ID
  ga4MeasurementId: import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-Y40PDLJEWN',

  // Enable/disable analytics in development environment
  enableInDevelopment: false
};
